import React from 'react';
import PropTypes from 'prop-types';
import CountUp from 'react-countup';
import { useMediaQuery } from '@material-ui/core';

const images = require.context('../../../../../images/reportingIcons', true);

const prefix = (words) => {
  // check border cases size 1 array and empty first word)
  if (!words[0] || words.length ==  1) return words[0] || "";
  let i = 0;
  // while all words have the same character at position i, increment i
  while(words[0][i] && words.every(w => w[i] === words[0][i]))
    i++;
  
  // prefix is the substring from the beginning to the last successfully checked i
  return words[0].substr(0, i);
}

const styles = {
  grid: {
    display: 'grid',
    gridColumnGap: '20px',
  },
  container: {
    color: '#ffffff',
    padding: '12px',
  },
  total: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '40px',
    fontWeight: 'bold',
    flexDirection: 'column',
    paddingRight: '5px'
  },
  values: {
    flexGrow: 1,
  },
  header: {
    fontSize: '20px',
    marginBottom: '20px',
  },
  content: {
    display: 'flex',

  },
  subrow: {
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer',
  },
  image: {
    verticalAlign: 'middle',
    width: '40px',
    margin: '15px',
  },
  hr: {
    borderStyle: 'solid',
  }
}

  const handleSubrowClick = (locationId, reportId, selectLocation, selectReport) => {

    selectLocation(locationId);
    if (reportId) {
      selectReport(reportId);
    }
  }

  const buildTitle = (row, titleOptions) => {

    const titleItems = titleOptions.map(t => row[t.attribute] ?? row[t.fallback]);

    return titleItems.join(' ');
  };

  const renderSubrow = (subrow, options, itemProgressAttribute, keyFigure, selectLocation, selectReport, prefixToRemove) => {
    return (
      <>
      <div style={styles.subrow} onClick={() => handleSubrowClick(subrow[options.itemUniqKey], keyFigure.linkedReport, selectLocation, selectReport)}>
        <span>
          {buildTitle(subrow, options.title).replace(prefixToRemove, '')}
        </span>
        <CountUp end={subrow[itemProgressAttribute]} suffix={keyFigure?.unit} />
      </div>
      <hr style={styles.hr} />
      </>
    )
  }

  const renderRow = (row, options, itemProgressAttribute, keyFigure, selectLocation, selectReport, index) => {

    const image = keyFigure?.image ? images(`./${keyFigure.image}`).default : null;

    const titles = row.values.map(r => buildTitle(r, options.title));
    const prefixToRemove = prefix(titles);
    return (
      <div style={{ ...styles.container, backgroundColor: keyFigure?.color }} className={keyFigure?.color ? '' : `key-figure-icon background-shade-${index}`}>
        <div style={styles.header}>{buildTitle(row, options.title)}</div>
        <div style={styles.content}>
          <div style={styles.total}>
            <img src={image} alt={keyFigure?.image} style={styles.image} />
            <CountUp end={row[itemProgressAttribute]} suffix={keyFigure?.unit} />
          </div>
          <div style={styles.values}>
            {row.values.map(subrow => renderSubrow(subrow, options, itemProgressAttribute, keyFigure, selectLocation, selectReport, prefixToRemove))}
          </div>
        </div>
      </div>
    );
  }

  const getGridColumns = (length) => {
    if (length % 2 === 0) {
      return '1fr 1fr';
    }
    if (length % 3 === 0) {
      return '1fr 1fr 1fr';
    }
    return '1fr';
  };

  function HierarchyKeyFigureVisualizer({ data, options, selectLocation, selectReport }) {
    const useDesktopLayout = useMediaQuery('(min-width:1200px)');

    let itemProgressAttribute = options.itemProgressAttribute
    || ((options.sortableAttributes && options.sortByAttribute)
      ? options.sortableAttributes[options.sortByAttribute].groupAttribute : null);

    // name is not a valid itemProgressAttribute, look for a different one instead
    if (itemProgressAttribute === 'name') {
      const sortAttributes = options.sortableAttributes
        ? Object.entries(options.sortableAttributes).map(sortable => sortable[1]) : [];
      itemProgressAttribute = sortAttributes.find(attribute => attribute.groupAttribute !== 'name').groupAttribute;
    }

    if (!itemProgressAttribute) {
      console.warn('Please provide a progress attribute option');
      return 'Bitte überprüfen Sie die Widgetkonfiguration ';
    }

    return (
      <div style={{ ...styles.grid, gridTemplateColumns: useDesktopLayout ? getGridColumns(data[0].length) : '1fr' }}>
        {data[0].map((row, i) => renderRow(row, options, itemProgressAttribute, options.keyFigures[i], selectLocation, selectReport, i))}
      </div>
    )
  }

HierarchyKeyFigureVisualizer.propTypes = {
  data: PropTypes.array,
  options: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]),
  selectLocation: PropTypes.func.isRequired,
  selectReport: PropTypes.func.isRequired,
};

HierarchyKeyFigureVisualizer.defaultProps = {
};

export default HierarchyKeyFigureVisualizer;
